import React from 'react';
import { useFormik } from 'formik';

import AppInput from '../../../base/input';

import kybUpdateValidationSchemas from '../../../../constants/schemas/kyb-update';

const BusinessLocation = () => {
  const formik = useFormik({
    initialValues: {
      businessName: '',
    },
    enableReinitialize: true,
    validationSchema: kybUpdateValidationSchemas[0],
    validateOnMount: true,
    onSubmit: () => {},
  });

  return (
    
    // <div className="p-4 rounded-xl gap-8 flex flex-col border border-[#F1F2F4] w-full h-full bg-white dark:bg-gray-800 text-gray-900 dark:text-white "> 
    <div className="p-4 rounded-xl gap-8 flex flex-col border border-[#F1F2F4] w-full h-full bg-white "> 
      <div className="grid gap-6">
        <p className="ryno_text_semibold ">
          Tell us about your business location
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Business Name */}
          <div>
            <AppInput
              type="text"
              name="businessName"
              id="businessName"
              onChange={formik.handleChange}
              placeholder="Enter your business name"
              required
              label="What is your business name?"
              onBlur={formik.handleBlur}
              value={formik.values.businessName}
              errorMessage={
                formik.touched.businessName && formik.errors.businessName
                  ? formik.errors.businessName
                  : ''
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessLocation;
